import { render } from "./App.vue?vue&type=template&id=470bbf34"
const script = {}

import "./App.vue?vue&type=style&index=0&id=470bbf34&lang=css"

import exportComponent from "/var/lib/docker/jenkins_home/workspace/web-cookingcrazy-cn/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__